<template>
  <v-app id="app">
    <NoticeSnackbar />

    <v-dialog
      v-model="logoutDialog"
      fullscreen
      transition="dialog-bottom-transition">
      <v-card class="d-flex align-center text-center" style="background: rgba(255, 255, 255, 0.96)">
        <div style="width: 100%">
          <div class="my-3 d-block">
            <div class="text-left pb-3" style="width: 60%; margin:0 auto">
              <h3 class="mb-3">Your session is about to end.</h3>
              You've been inactive for a while. For your security, we'll automatically sign you out in 1 minute. You may choose "Stay signed in" to continue or sign out if you're done.
            </div>
          </div>
          <v-progress-linear
            v-model="progressValue"
            color="primary"
            height="80"
            class="mb-6">
        </v-progress-linear>
          <v-btn
            text
            outlined
            class="my-3 mr-3"
            color="primary"
            @click="logOut()">
            Sign Out
          </v-btn>
          <v-btn
            class="my-3 ml-3"
            color="primary"
            @click="stopProgress()">
            Stay signed in
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    
    <v-app-bar v-if="authenticated && !$route.name.includes('printable')" color="primary darken-1" class="mx-0" elevation="2" absolute>

      <v-img :src="logo" max-width="140" class="ma-0 mb-1 ml-n2" atl="Succession Resource Group"></v-img>
      <v-spacer></v-spacer>

          <v-toolbar-items class="mx-0">
            <v-menu 
              v-model="menu_visibility" 
              open-on-hover 
              close-on-content-click 
              offset-y
              style="z-index: 2000">
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" class="white--text">
                  <v-icon>mdi-chevron-down</v-icon>
                  <span class="button_text text-capitalize text_condensed">Admin Controls</span>
                </v-btn>
              </template>
              <v-list>
                <div
                  v-for="(item, index) in controls"
                  :key="item.route || item.title || index"
                  style="display: contents;"
                >
                  <v-list-item v-if="!item.children" :to="item.route">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                  
                  <v-list-group v-else no-action @click.stop="">
                    
                    <template v-slot:activator>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </template>
                    <v-list-item v-for="(kid, kndex) in item.children" :to="kid.route" :key="kid.route || kid.title || kndex">
                      <v-list-item-title>{{ kid.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list-group>
                </div>
 
              </v-list>
            </v-menu>

            <v-divider vertical color="#0A5B64"></v-divider>

            <v-btn text class="white--text px-6" :href="mycompass_url" target="_blank">
                <v-icon left medium>mdi-compass-outline</v-icon>
                <span class="button_text text-lowercase text_condensed">my</span><span class="button_text text-capitalize text_condensed">Compass</span>
                <v-icon right x-small class="mt-1">mdi-open-in-new</v-icon>
            </v-btn>

            <v-divider vertical color="#0A5B64"></v-divider>

            <v-btn text class="white--text px-6" to="/account">
                <v-icon left medium>mdi-home</v-icon>
                <span class="button_text text-capitalize text_condensed">Account</span>
            </v-btn>

            <v-divider vertical color="#0A5B64"></v-divider>

            <v-btn text class="white--text px-6" @click.native="logOut">
                <v-icon left medium>mdi-logout</v-icon>
                <span class="button_text text-capitalize text_condensed">Logout</span>
            </v-btn>
          </v-toolbar-items>

      </v-app-bar>

      <v-content class="content">
        <router-view @authenticated="setAuthenticated()"></router-view>
      </v-content>

  </v-app>
</template>

<script>
    import Cookie from 'js-cookie'
    import appUrls from './helpers/environment'

    import logo_img from './assets/SRGLogo_white_2022.svg';
    import fonts from './assets/css/fonts.css';
    import './assets/css/data-tables.css';
    import NoticeSnackbar from './components/shared/noticeSnackbar';

  export default {
    name: 'App',

    components: {
      NoticeSnackbar
    },

    data() {
      return {
        authenticated: false,
        isSuperAdmin: false,
        mycompass_url: appUrls.mycompass,
        logo: logo_img,
        menu_visibility: false,
        controls: [
          { title: 'Tasks', route: '/task_dashboard' },
          { title: 'Projects', route: '/projects' },
          { title: 'Users', route: '/users' },
          { title: 'Modules', route: '/modules' },
          { title: 'Listings', route: '/listings' },
          { title: 'Reports', route: '/reports',
            children: [
              { title: 'Buyers', route: '/reports'},
              { title: 'EMP', route: '/emp_reports'},
            ]
          },
          { title: 'Charts', route: '/chart_dashboard' },
          { title: 'Manage Data', route: '/datamanagement' }
        ],
        inactivityTime: 8 * 60 * 60 * 1000, // 8 * 60 * 60 * 1000 == 28800000 = 8 hours in milliseconds //// 15 * 60 * 1000 == 900000 = 15 minutes in milliseconds
        logoutTimer: false,
        logoutDialog: false,
        progressValue: 0, // initial progress value
        duration: 60, // duration in seconds
        timer: null,
        interval: 100, // interval for updating progress (milliseconds)
        stopped: false, // flag to indicate if the process was stopped
      }
    },

    watch: {
      authenticated: function(bool) {
        if ( bool ) {
          document.addEventListener("mousemove", () => {
            if ( Cookie.get('token') ) {
              this.resetTimer()
            }
          })
          document.addEventListener("keypress", () => {
            if ( Cookie.get('token') ) {
              this.resetTimer()
            }
          })
          // Start the timer when the page loads
          this.resetTimer()
        }
      }
    },

    mounted () {
      this.setAuthenticated()
    },
    
    beforeDestroy() {
      clearInterval(this.timer); // Clear the timer on component destroy
    },
    
    methods: {
      setAuthenticated: function () {
        this.authenticated = Cookie.get('token') ? true : false;

        if ( this.authenticated && !['root','super'].includes(Cookie.get('levs')) ) {
          this.controls = this.controls.filter(item => item.title != 'Charts')
        }

        if ( !this.authenticated ) {
          this.$router.replace({ name: 'login' }).catch(err => {});
        }
      },
    
      logOut: function () {
        Cookie.remove('token')
        Cookie.remove('name')
        Cookie.remove('bool')
        Cookie.remove('levs')
        Cookie.remove('srge')

        localStorage.removeItem('activityLogFilters')
        localStorage.removeItem('taskDashboardFilters')
        localStorage.removeItem('projectDashboardFilters')

        this.logoutDialog = false
        this.authenticated = false
       
        clearInterval(this.timer)
        clearTimeout(this.logoutTimer)
        this.timer = null
        this.progressValue = 0
        this.stopped = false

        this.$router.replace({ name: 'login' }).catch(err => {})
      },

      logoutWarn: function () {
        // this.logoutDialog = true
        // this.startProgress()
        this.logOut()
      },

      resetTimer: function () {
        clearTimeout(this.logoutTimer);
        this.logoutTimer = setTimeout(this.logoutWarn, this.inactivityTime);
      },

      startProgress: function () {
        // document.addEventListener("mousemove", () => {
        //   if ( Cookie.get('token') ) {
        //     clearInterval(this.timer)
        //     clearTimeout(this.logoutTimer)
        //     this.stopped = true
        //     this.timer = null
        //     this.resetTimer()
        //     this.stopped = false
        //     return
        //   }
        // })

        const steps = Math.ceil((this.duration * 1000) / this.interval);
        let count = 0;

        this.timer = setInterval(() => {
          if (!this.stopped) {
            count++;
            this.progressValue = (count / steps) * 100;

            if (this.progressValue >= 100) {
              clearInterval(this.timer);
              setTimeout ( () => {
                this.logOut()
              }, 200)
            }
          }
        }, this.interval);
      },

      stopProgress: function () {
        clearInterval(this.timer)
        clearTimeout(this.logoutTimer)
        this.stopped = true
        this.timer = null
        this.progressValue = 0
        this.logoutDialog = false
        this.resetTimer()
        this.stopped = false
      }
    }
  }
</script>

<style>
  /* html { 
    overflow-y: auto !important;
  } */
  #app {
    font-family: 'AvenirBook', Arial, Helvetica, sans-serif;
    background-color: rgba(250, 252, 252, 0.5);
  }
  .sansation {
    font-family: 'Sansation';
    font-size: 1rem !important;
  }
  .sansation_title {
    font-family: 'Sansation';
    font-size: 1.6rem !important;
    font-weight: bold;
  }
  .sansation_subtitle {
    font-family: 'Sansation';
    font-size: 1.3rem !important;
  }
  .sansation_headline {
    font-family: 'Sansation';
    font-size: 1.5rem !important;
    font-weight: bold;
  }
  .avenir_book {
    font-family: 'AvenirBook';
  }
  .avenir_medium {
    font-family: 'AvenirMedium';
  }
  .avenir_black {
    font-family: 'AvenirBlack';
  }
  .label_medium {
    font-size: medium;
  }
  .label_large {
    font-size: large;
  }
  .font_size_1rem {
    font-size: 1rem !important;
  }

  .content {
    margin: 0;
    padding: 0;
  }

  .button_text {
    /* font-family: 'Sansation'; */
    font-size:1.25em;
  }
  .menu_border {
    border-bottom: 1px solid #BBB
  }
  .text_condensed {
    letter-spacing: 0rem;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue